import { AuthLayout } from '@/design-system/layouts'
import { ResetPassword } from '../components'

export function ResetPasswordPage() {
  return (
    <AuthLayout>
      <ResetPassword />
    </AuthLayout>
  )
}
